import { useEffect, useState } from "react";
import useService from "./useService";
import { useAuth } from "@with-nx/auth";

export type CustomizationRequest = {
  id: number;
  rental_id: number;
  order_id: number;
  customization_request_files: {
    id: number;
    video_set_id: number;
    file_url: string;
    customized_file_url: string | null;
  }[];
};

export const useCustomizationRequest = (
  rental: number,
  callback?: (data: CustomizationRequest) => void
) => {
  const [all, _all] = useState<CustomizationRequest[]>([]);
  const [data, _data] = useState<CustomizationRequest>();
  const [loading, _loading] = useState<boolean>(true);
  const auth = useAuth();

  useEffect(() => {
    _loading(true);

    if (!auth.authState.session?.token) {
      return;
    }

    (async () => {
      const service = useService("accounts");

      const all = (await service(
        "GET",
        `/api/v2/customization_requests`,
        undefined,
        {
          Authorization: `Bearer ${auth.authState.session?.token}`,
        }
      )) as {
        data: CustomizationRequest[];
      };

      _all(all?.data || []);

      const find = all.data.find(
        (item) => Number(item.rental_id) === Number(rental)
      );

      if (find) {
        callback?.(find);
        console.log(find);
      }

      _data(find);
      _loading(false);
    })();
  }, [rental ?? 0, auth.authState.session?.token]);

  return {
    all,
    data,
    loading,
  };
};
